// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__bLibH","checkboxCol":"Table_checkboxCol__1J_Y3","emailCol":"Table_emailCol___-x7H","actionCol":"Table_actionCol__3xNSe"};